module.exports = __webpack_public_path__ + "fonts/WorkSans-Light.dbba449.woff2";